(function () {
    // function handleIntersection(entries, observer) {
    //     entries.forEach(entry => {
    //         const video = entry.target;
    //         if (!entry.isIntersecting) {
    //             video.pause();
    //         }  
    //     });
    
    // }

    // const observer = new IntersectionObserver(handleIntersection, {
    //     root: null, 
    //     rootMargin: '0px', 
    //     threshold: 0.5 
    // });

    const tabButtons = document.querySelectorAll('.acc-odh-lp-04-03-tab-button');
    const tabContents = document.querySelectorAll('.acc-odh-lp-04-03-tab-content');

    tabButtons.forEach(button => {
        button.addEventListener('click', function () {
            tabButtons.forEach(btn => btn.classList.remove('active'));

            button.classList.add('active');

            tabContents.forEach(content => content.classList.remove('active'));

            const tabId = button.getAttribute('data-tab');
            document.getElementById(tabId).classList.add('active');
        });
    });

    function togglePlayPause(event) {
        const videoContainer = event.target.closest('.acc-odh-lp-04-03-video-container');
        const video = videoContainer.querySelector('video');

        if (video.paused) {
          video.controls=!0;
          video.muted=!1;
            video.play();
        } else {
            video.pause();
        }
    }

    const playButtons = document.querySelectorAll('.acc-odh-lp-04-03-play-button');
    playButtons.forEach(button => {
        button.addEventListener('click', togglePlayPause);
    });

    const videoContainers = document.querySelectorAll('.acc-odh-lp-04-03-video-container');
    videoContainers.forEach(container => {
        const video = container.querySelector('video');

        video.addEventListener('play', () => {
            container.classList.remove('paused');
        });

        // video.addEventListener('pause', () => {
        //     container.classList.add('paused');
        // });

        video.addEventListener('click', (e) => {
            // container.classList.toggle('paused');
            // togglePlayPause(e);
            container.classList.remove('paused');
            !video.played?.length&&togglePlayPause(e);
        },{once:!0});

        // observer.observe(video);
    });
})();